import { Component, OnInit } from '@angular/core';
import { ApiService } from '../../api.service';
import { Entity } from '../select-list/select-list.component';
import { MyUtility } from '../../comparison';

@Component({
  selector: 'app-organisms',
  templateUrl: './organisms.component.html',
  styleUrls: ['./organisms.component.css']
})
export class OrganismsComponent implements OnInit {
  public title : string;
  constructor(public api : ApiService) 
  {
  }

  ngOnInit() {
    
  }

  get items(){
    return this.api.session.currentCriteria.organisms.selectedCategory.children;
  }

  get selectedItems(){
    return this.api.session.currentCriteria.organisms.selectedItems;
  }
  set selectedItems(value){
    MyUtility.scrubChildren(value);
    this.api.session.currentCriteria.organisms.selectedItems = value;
  }

  clearCurrent(){
    this.selectedItems = [];
    this.api.session.currentCriteria.organisms.groupName = null;
  }
}
